/* eslint-disable import/no-anonymous-default-export */
export default {
  global: {
    body: {
      bg: "background",
      color: "text",
      fontWeight: "400",
      minHeight: "100svh",
    },
  },
};
